export default __webpack_public_path__ + "static/message-sent-vector-1d7192367df9a82630079486b7949d4a.svg";